import { LOCATIONS_CODES_TO_ID_MAPPING } from '../config/constants';

export const mapCountries = (locations) =>
    locations
        ?.filter(Boolean)
        .sort()
        .map((elem) => {
            try {
                const countryCode = resolveCountryCode(elem);
                return new Intl.DisplayNames(['en'], { type: 'region' })?.of(countryCode);
            } catch (e) {
                return elem;
            }
        })
        .join(', ');

export function resolveCountryCode(countryCode) {
    const countryCodeId = parseInt(countryCode, 10);
    if (Number.isNaN(countryCodeId)) {
        return countryCode;
    }

    return LOCATIONS_CODES_TO_ID_MAPPING.find((item) => item.id === countryCodeId)?.code;
}
